import moment from "moment";

export const getTotalExperience = (additionalYears = 0) => {
  const startDate = "2020-08-01";
  const start = moment(startDate);
  const now = moment();

  const totalMonths = now.diff(start, "months") + 1;

  const years = Math.floor((totalMonths + additionalYears) / 12);
  const months = totalMonths % 12;

  if (months === 0) {
    return `${years} years`;
  } else if (months <= 3) {
    return `over ${years} years`;
  } else if (months >= 4 && months <= 6) {
    return `around ${years}.5 years`;
  } else if (months >= 7 && months <= 9) {
    return `over ${years}.5 years`;
  } else {
    return `around ${years + 1} years`;
  }
};

export const getCurrentJobMonths = (
  joiningDate = new Date("October 1, 2025")
) => {
  const currentDate = new Date();

  const monthsDiff =
    (currentDate.getFullYear() - joiningDate.getFullYear()) * 12 +
    (currentDate.getMonth() - joiningDate.getMonth());

  return monthsDiff + (currentDate.getDate() >= joiningDate.getDate() ? 1 : 0);
};
